import React, { useState } from 'react';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Grid from '@material-ui/core/Grid';
import PERSONALITY from 'constant/personality-types';
import GeneralInfoForm from 'modules/student/profile/profileForms/General';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import Box from '@material-ui/core/Box';
import Button from 'components/common/Button';
import IconButton from '@material-ui/core/IconButton';
import LaunchIcon from '@material-ui/icons/Launch';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Field from './Field';

const useStyles = makeStyles({
  root: {
    textAlign: 'center',
  },
});


const Screenshot = ({ onClose, url }) => {
  const classes = useStyles();

  return (
    <Dialog open fullWidth maxWidth="md">
      <DialogContent
        classes={{
          root: classes.root,
        }}
      >
        <img src={url} alt="result-screenshot"/>
        <Box
          textAlign="right"
          paddingTop={3}
          paddingBottom={3}
          onClick={onClose}
        >
          <Button variant="contained" color="primary">
            Close
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

const GeneralInfo = ({ student, editable, profile: { personal_info } }) => {
  const [showDetails, toggleDetails] = useState(false);

  const screenshot = personal_info.personality_result_url;
 return <GeneralInfoForm user={student} editable={editable}/>;
  return (
    <Card>
      <CardContent>
        <Grid container spacing={2}>
          <Grid item md={4}>
            <Field value={student.user_first_name} label="First name" />
          </Grid>
          <Grid item md={4}>
            <Field value={student.user_last_name} label="Last name" />
          </Grid>
          <Grid item md={4}>
            <Field value={student.user_preferred_name} label="Preferred name" />
          </Grid>
          <Grid item md={4}>
            <Field value={student.gender_pronounce} label="Gender Pronouns" />
          </Grid>
        </Grid>
        <Grid container spacing={2}>
          <Grid item md={4}>
            <Field value={student.user_email} label="Email" />
          </Grid>
          <Grid item md={4}>
            <Field value={student.user_phone} label="Phone" />
          </Grid>
        </Grid>
        <Grid container spacing={2}>
          <Grid item md={4}>
            <Field value={student.state} label="State of Residence" />
          </Grid>
        </Grid>
        <Field
          value={
            PERSONALITY.find((i) => i.value === personal_info.personality_type)
              ?.label
          }
          label={`Personality Type`}
        />
        { screenshot && (
          <Box display="flex">
            <Typography color="textPrimary" variant="body2">
              View Screenshot
            </Typography>{' '}
            <IconButton
              size="small"
              style={{ marginRight: 'auto', paddingTop: 0 }}
              onClick={() => toggleDetails(true)}
            >
              <LaunchIcon fontSize="small" color="disabled" />
            </IconButton>
          </Box>
        )}
      </CardContent>
      {showDetails && (
        <Screenshot
          url={screenshot}
          onClose={() => toggleDetails(false)}
        />
      )}
    </Card>
  );
};

export default GeneralInfo;
